<template>
  <main id="main" class="main">
    <div class="pagetitle">
      <div class="d-flex justify-content-between align-items-center">
        <div class="row">
            <div class="col-sm-12">
            <div class="pagetitle"> 
                <h1 class="text-left">API DOCUMENTATION</h1>
                <nav>
                <ol class="breadcrumb breadJa">
                    <router-link :to="{ name: 'home' }" class="breadcrumb-item">Home</router-link>
                    <router-link :to="{ name: 'doc' }" class="breadcrumb-item">Documentation</router-link>
                </ol>
                </nav>
            </div>
            </div> 
            <div class="col-3">
            <!-- button tambahan -->
            </div>
        </div>
        <div>
          <a 
            href="https://sudevwa.apidog.io/" 
            target="_blank" 
            class="btn btn-primary"
          >
            <i class="bi bi-arrow-up-right-square me-2"></i>
            Open in New Tab
          </a>
        </div>
      </div>
    </div>

    <section class="section">
        <div class="iframe-container">
            <iframe 
                ref="apiFrame"
                src="https://sudevwa.apidog.io/" 
                :style="iframeStyle"
                title="API Documentation"
                @load="onIframeLoad"
            ></iframe>
            
            <div v-if="loading" class="iframe-loading">
                <div class="illustration-container">
                    <Vue3Lottie  
                        animationLink="/assets/apiloading.json"
                        :height="700" 
                        :width="700"
                        :loop="true"
                        :autoPlay="true"
                    />
                </div>
            </div>
        </div>
    </section>
  </main>
</template>

<script>

import { Vue3Lottie } from 'vue3-lottie';
export default {
    components:{
        Vue3Lottie
    },
    name: 'ApiDocs',
    data() {
        return {
        loading: true,
        customHeight: 700
        }
    },
    computed: {
        iframeStyle() {
        return {
            width: '100%',
            height: `${this.customHeight}px`, // Fixed height
            border: 'none',
            borderRadius: '8px',
            display: this.loading ? 'none' : 'block'
        }
        }
    },
    methods: {
        onIframeLoad() {
        this.loading = false;
        }
    }
}
</script>

<style scoped>
.iframe-loading {
  position: absolute;
  top: 50%;
  left: 55%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  z-index: 10;
}

.illustration-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0;
}

/* Override Lottie wrapper jika ada extra space */
.illustration-container >>> div {
  line-height: 0;
  display: block;
}

</style>
